import React from 'react';
import { Button } from 'reactstrap';
import { useSelector } from 'react-redux';
import { buttonStyle } from 'components/Containers/ConfigurationContainer/components/utils';

/**
 * Um componente de botão React personalizável que aplica estilos baseados nas cores de configuração do sistema.
 *
 * @component
 * @param {Object} props - As propriedades do componente
 * @param {string} [props.btnColor='primary'] - Tipo de cor do botão ('confirmation', 'cancelation', 'primary', 'secondary')
 * @param {React.ReactNode} props.children - Elementos filhos a serem renderizados dentro do botão
 * @returns {JSX.Element} Um componente Button estilizado
 *
 * @example
 * <ReactButton btnColor="confirmation">Confirmar</ReactButton>
 */
export default function ReactButton(props) {
  const {
    confirmation_button_color,
    cancelation_button_color,
    primary_color,
    secondary_color
  } = useSelector((state) => state.systemConfiguration);

  function getStyle(type) {
    switch (type) {
      case 'confirmation':
        return buttonStyle(confirmation_button_color);
      case 'cancelation':
        return buttonStyle(cancelation_button_color);
      case 'primary':
        return buttonStyle(primary_color);
      case 'secondary':
        return buttonStyle(secondary_color);
      default:
        return buttonStyle(primary_color);
    }
  }

  const { style, ...restProps } = props;

  return (
    <Button style={{ ...getStyle(props.btnColor), ...style }} {...restProps}>
      {props.children}
    </Button>
  );
}
